<template>
  <div
    v-if="!$store.state.users.homeReloaded"
    class="row main-content"
  >
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.passwordchange') }}
      </h1>
      <div class="info alert alert-warning">
        <p><strong>{{ $t('label.password.information') }}</strong></p>
        <p>{{ $t('label.password.inputPasswordRules1') }}</p>
        <p>{{ $t('label.password.inputPasswordRules2') }}</p>
        <p>{{ $t('label.password.inputPasswordRules3') }}</p>
        <p>{{ $t('label.password.inputPasswordRules4') }}</p>
        <p>
          {{ $t('label.password.inputPasswordRules5') }}
        </p>
        <p>{{ $t('label.password.inputPasswordRules6') }}</p>
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t(`${responseErr}`) }}
          </strong>
        </div>

        <div id="accordion">
          <div class="card rounded-0 mb-4">
            <div
              id="headingOne"
              data-bs-toggle="collapse"
              href="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              class="card-header font-accent fw-bold"
            >
              {{ $t('title.passwordchange') }}
            </div>
            <div
              id="collapseOne"
              aria-labelledby="headingOne"
              data-bs-parent="#accordion"
              class="card-body collapse show"
            >
              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.password.infoChangePassword') }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-body bg-light mb-4">
        <div class="text-end">
          <button
            type="button"
            class="btn btn-default btn-reset rounded-pill font-custom me-2"
            @click="leavePage()"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export custom-reset-btn"
            @click="updatePassword()"
          >
            {{ $t("button.reinitPwd") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div
      id="successModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="successModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-success">
              <p id="successModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div
      id="errorModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="errorModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="errorModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.ERROR_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <p id="errorModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./PasswordChange.js"></script>

<style src="./PasswordChange.scss" scoped lang="scss"></style>
